<template>
    <div id="whiteboard">
        <div class="placeholder"></div>
    </div>
</template>
<script>
// const { eventEmitter } = BJY;
export default {
  name: 'whiteBoard',
  data() {
    return {

    };
  },
  mounted() {
    // 新版白板
    /* eslint-disable */
    this.whiteboard = BJY.Whiteboard.create({
      element: $('#whiteboard .placeholder'),
      // 填充模式： 1 自适应  2 撑满容器
      fit: 1,
      keepSize: false,
      // 给静态文档添加水印，如不需要可忽略。sdkVersion >= 0.3.1
      watermark: {
        text: 'qihang', // 水印文字，必传，不宜过长，否则阿里云图片处理会出错
        opacity: 0, // 可选，透明度
        size: 36, // 可选，字号
        rotate: 20, // 可选，旋转角度
        fill: 1, // 可选，是否铺满 0/1，默认1
      },
    });
  },
  beforeDestroy() {
    this.whiteboard && this.whiteboard.destroy();
  },
};
</script>
<style lang="scss" scoped>
#whiteboard {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
